var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistintoDe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_5893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15.3636L16.8864 23.7273H15.5682L15.4545 15.3636H17ZM16.2273 27.0909C15.947 27.0909 15.7064 26.9905 15.5057 26.7898C15.3049 26.589 15.2045 26.3485 15.2045 26.0682C15.2045 25.7879 15.3049 25.5473 15.5057 25.3466C15.7064 25.1458 15.947 25.0455 16.2273 25.0455C16.5076 25.0455 16.7481 25.1458 16.9489 25.3466C17.1496 25.5473 17.25 25.7879 17.25 26.0682C17.25 26.2538 17.2027 26.4242 17.108 26.5795C17.017 26.7348 16.8939 26.8598 16.7386 26.9545C16.5871 27.0455 16.4167 27.0909 16.2273 27.0909ZM20.2259 20.1136V18.8864H27.2259V20.1136H20.2259ZM20.2259 23.4773V22.25H27.2259V23.4773H20.2259Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_5893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistintoDe);
export default __webpack_public_path__ + "static/media/DistintoDe.c8767c4769c933d93bd870725bc72836.svg";
export { ForwardRef as ReactComponent };